/**
 * Mock data for Collector Reconciliation (CC ↔ CR) — development only
 * Remove this file once the backend endpoint is available
 */

import type { CollectorReconciliationData } from '@/types/collector-reconciliation.types';

export const COLLECTOR_MOCK_DATA: CollectorReconciliationData = {
  resumen: {
    year: 2026,
    totalCredits: 15,
    totalCollectionRecords: 180,
    totalCreditContracts: 98,
    timings: { credits_ms: 45, collectionRecords_ms: 120, creditContracts_ms: 180 },
    totals: { ok: 88, descuadre: 3, soloCC: 1, soloCR: 2 },
  },

  meses: {
    '1': { ok: 6, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(6, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '2': { ok: 8, soloCC: 0, soloCR: 0, descuadre: 1, detalles: { ok: mockDetailRows(8, 'cc-ok'), soloCC: [], soloCR: [], descuadre: mockDetailRows(1, 'cc-descuadre') } },
    '3': { ok: 12, soloCC: 0, soloCR: 1, descuadre: 0, detalles: { ok: mockDetailRows(12, 'cc-ok'), soloCC: [], soloCR: mockDetailRows(1, 'solo-cr'), descuadre: [] } },
    '4': { ok: 10, soloCC: 1, soloCR: 0, descuadre: 1, detalles: { ok: mockDetailRows(10, 'cc-ok'), soloCC: mockDetailRows(1, 'solo-cc'), soloCR: [], descuadre: mockDetailRows(1, 'cc-descuadre') } },
    '5': { ok: 9, soloCC: 0, soloCR: 1, descuadre: 0, detalles: { ok: mockDetailRows(9, 'cc-ok'), soloCC: [], soloCR: mockDetailRows(1, 'solo-cr'), descuadre: [] } },
    '6': { ok: 11, soloCC: 0, soloCR: 0, descuadre: 1, detalles: { ok: mockDetailRows(11, 'cc-ok'), soloCC: [], soloCR: [], descuadre: mockDetailRows(1, 'cc-descuadre') } },
    '7': { ok: 7, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(7, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '8': { ok: 8, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(8, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '9': { ok: 5, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(5, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '10': { ok: 6, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(6, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '11': { ok: 4, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(4, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
    '12': { ok: 2, soloCC: 0, soloCR: 0, descuadre: 0, detalles: { ok: mockDetailRows(2, 'cc-ok'), soloCC: [], soloCR: [], descuadre: [] } },
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

function mockId() {
  return crypto.randomUUID().slice(0, 8);
}

function mockDate(month: number) {
  const day = Math.floor(Math.random() * 28) + 1;
  return `2026-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(Math.floor(Math.random() * 24)).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}:00.000Z`;
}

function mockDetailRows(count: number, type: string): Record<string, unknown>[] {
  const paymentTypes = ['REGULAR', 'ADVANCED', 'ANTICIPATED', 'SETTLEMENT'];
  return Array.from({ length: count }, (_, i) => {
    const creditId = mockId();
    const ccId = mockId();
    const month = Math.floor(Math.random() * 12) + 1;
    const notional = 350 + Math.floor(Math.random() * 300);
    const fee = Math.floor(notional * 0.06);
    const tax = Math.floor(fee * 0.16);
    const paymentType = paymentTypes[Math.floor(Math.random() * paymentTypes.length)]!;

    switch (type) {
      case 'cc-ok': {
        return {
          ccId,
          ccStatus: ['COBRADO', 'SALDADO'][Math.floor(Math.random() * 2)],
          ccCreateDate: mockDate(month),
          ccCreditNotional: notional,
          ccCreditTotal: notional + fee + tax,
          ccCreditFee: fee,
          ccCreditTax: tax,
          ccRelatedTransaction: paymentType === 'REGULAR'
            ? `CREDIT-${creditId}-COUPON-${i + 1}`
            : `${paymentType}-${creditId}-${Date.now()}`,
          ccDirectoryId: `dir-${mockId()}`,
          ccTenantId: 'FIADOSA',
          ccCollectionType: 'DEBIT',
          sumaColectadaCR: notional,
          diferencia: 0,
          cantidadCRs: paymentType === 'REGULAR' ? 1 : Math.floor(Math.random() * 3) + 1,
          records: [
            { credit_id: creditId, coupon_number: i + 1, payment_type: paymentType, amount_collected_mxn: notional, collection_status: 'COMPLETED' },
          ],
        };
      }
      case 'cc-descuadre': {
        const collected = notional - 15 - Math.floor(Math.random() * 50);
        return {
          ccId,
          ccStatus: 'COBRADO',
          ccCreateDate: mockDate(month),
          ccCreditNotional: notional,
          ccCreditTotal: notional + fee + tax,
          ccCreditFee: fee,
          ccCreditTax: tax,
          ccRelatedTransaction: `CREDIT-${creditId}-COUPON-${i + 1}`,
          ccDirectoryId: `dir-${mockId()}`,
          ccTenantId: 'FIADOSA',
          ccCollectionType: 'DEBIT',
          sumaColectadaCR: collected,
          diferencia: collected - notional,
          cantidadCRs: 1,
          records: [
            { credit_id: creditId, coupon_number: i + 1, payment_type: 'REGULAR', amount_collected_mxn: collected, collection_status: 'COMPLETED' },
          ],
        };
      }
      case 'solo-cc': {
        return {
          ccId,
          ccStatus: 'ORIGINADO',
          ccCreateDate: mockDate(month),
          ccCreditNotional: notional,
          ccCreditTotal: notional + fee + tax,
          ccCreditFee: fee,
          ccCreditTax: tax,
          ccRelatedTransaction: `CREDIT-${creditId}-COUPON-${i + 1}`,
          ccDirectoryId: `dir-${mockId()}`,
          ccTenantId: 'FIADOSA',
          ccCollectionType: 'DEBIT',
        };
      }
      case 'solo-cr': {
        return {
          creditContractId: `nonexistent-${mockId()}`,
          creditId,
          couponNumber: i + 1,
          paymentType,
          amountCollectedMxn: notional,
          collectionStatus: 'COMPLETED',
        };
      }
      default:
        return { ccId, ccCreateDate: mockDate(month) };
    }
  });
}
